import React from 'react';
import { CalendarX } from 'lucide-react';

const PlanExpired = () => (
    <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
    }}>
        <div className="card" style={{
            maxWidth: '480px',
            width: '100%',
            padding: '3rem 2.5rem',
            textAlign: 'center',
        }}>
            <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 1.5rem',
            }}>
                <CalendarX size={32} />
            </div>
            <h2 style={{ marginBottom: '0.75rem' }}>Plan Expired</h2>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.6 }}>
                Your organisation's plan has expired, so access to the workspace is
                currently paused. Your data is safe.
            </p>
            <p style={{ color: 'var(--text-muted)', lineHeight: 1.6, marginTop: '0.75rem' }}>
                Please contact your platform administrator or support team to renew the plan
                and restore access.
            </p>
        </div>
    </div>
);

export default PlanExpired;
